// Wave TW-1.f.9 (2026-05-24) — admin 분쟁 검토 큐 페이지
// API:
//   GET /api/transactions/disputes → { items: tx_confirm[] }
//   POST /api/transactions/:id/resolve-dispute { resolution, note }

import React, { useState, useEffect, useCallback } from 'react';

function authHeaders() {
  var tok = '';
  try { tok = localStorage.getItem('autodoc_token') || ''; } catch (e) {}
  return tok ? { 'Authorization': 'Bearer ' + tok } : {};
}

function AdminDisputesPage(props) {
  var showToast = props.showToast || function () {};
  var [items, setItems] = useState([]);
  var [loading, setLoading] = useState(true);
  var [error, setError] = useState('');
  var [busyId, setBusyId] = useState(0);

  var load = useCallback(function () {
    setLoading(true); setError('');
    fetch('/api/transactions/disputes', { headers: authHeaders() })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.success && d.data) {
          setItems(d.data.items || []);
        } else {
          setError((d && d.error) || '목록 조회 실패');
        }
        setLoading(false);
      })
      .catch(function () { setError('네트워크 오류'); setLoading(false); });
  }, []);

  useEffect(function () { load(); }, [load]);

  var onResolve = function (row, resolution) {
    var msg = resolution === 'resolved'
      ? '분쟁을 인정하시겠습니까?\n신고자 측 손을 들어줍니다.'
      : '분쟁을 기각하시겠습니까?\n거래는 정상 진행됩니다.';
    if (!window.confirm(msg)) return;
    var note = window.prompt('admin 메모 (선택, 500자)', '');
    if (note === null) return;
    setBusyId(row.id);
    fetch('/api/transactions/' + row.id + '/resolve-dispute', {
      method: 'POST',
      headers: Object.assign({ 'Content-Type': 'application/json' }, authHeaders()),
      body: JSON.stringify({ resolution: resolution, note: String(note).slice(0, 500) }),
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        setBusyId(0);
        if (d && d.success) {
          // Wave TW-1.f.16 — 페널티/blacklist 결과 toast 확장 표시
          var lines = [resolution === 'resolved' ? '분쟁 인정 처리됨' : '분쟁 기각 처리됨'];
          if (d.sellerPenalty && d.sellerPenalty.applied) {
            lines.push('· 출품자 회사 ' + d.sellerPenalty.delta + '° (현재 ' + (d.sellerPenalty.newTemp != null ? d.sellerPenalty.newTemp.toFixed(1) + '°' : '?') + ')');
          }
          if (d.buyerPenalty && d.buyerPenalty.applied) {
            lines.push('· 외부 바이어 ' + d.buyerPenalty.delta + '° (현재 ' + (d.buyerPenalty.newTemp != null ? d.buyerPenalty.newTemp.toFixed(1) + '°' : '?') + ')');
          }
          if (d.blacklist && d.blacklist.added) {
            lines.push('· blacklist 등록 (' + d.blacklist.businessNo + ', 누적 ' + d.blacklist.count + '건)');
          }
          showToast(lines.join('\n'), 'success');
          load();
        } else {
          showToast((d && d.error) || '처리 실패', 'error');
        }
      })
      .catch(function () { setBusyId(0); showToast('네트워크 오류', 'error'); });
  };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: '#0f172a', margin: 0 }}>🚨 거래 분쟁 검토</h2>
        <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>
          신고된 거래를 검토하고 인정 / 기각 처리합니다. (admin 전용)
        </div>
      </div>

      {loading && (
        <div style={{ padding: '60px 0', textAlign: 'center', color: '#94a3b8' }}>로딩 중…</div>
      )}

      {!loading && error && (
        <div style={{ padding: '60px 0', textAlign: 'center' }}>
          <div style={{ color: '#dc2626', marginBottom: 12 }}>{error}</div>
          <button type="button" onClick={load}
            style={{ padding: '8px 16px', background: 'white', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 13, fontWeight: 600, color: '#475569', cursor: 'pointer' }}>
            다시 시도
          </button>
        </div>
      )}

      {!loading && !error && items.length === 0 && (
        <div style={{ padding: '60px 0', textAlign: 'center', color: '#94a3b8' }}>
          <div style={{ fontSize: 48, opacity: 0.4 }}>✅</div>
          <div style={{ fontSize: 16, fontWeight: 600, marginTop: 8 }}>검토 대기 중인 분쟁이 없습니다</div>
        </div>
      )}

      {!loading && !error && items.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))', gap: 16 }}>
          {items.map(function (row) {
            var sourceLabel = row.source_type === 'rfq' ? '사전조회' : '경매';
            var partyLabel = row.dispute_party === 'seller' ? '출품자' : '바이어';
            return (
              <div key={row.id}
                style={{ background: 'white', border: '1px solid #fecaca', borderRadius: 12, padding: 16, boxShadow: '0 1px 4px rgba(220,38,38,0.08)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                  <span style={{ fontSize: 11, fontWeight: 700, color: '#1B3A5C', background: '#eff6ff', padding: '3px 8px', borderRadius: 6 }}>
                    {sourceLabel} #{row.source_id}
                  </span>
                  <span style={{ fontSize: 10, color: '#991b1b', background: '#fee2e2', padding: '2px 8px', borderRadius: 4, fontWeight: 700 }}>
                    {partyLabel} 신고
                  </span>
                </div>
                {row.amount && (
                  <div style={{ fontSize: 16, fontWeight: 800, color: '#0f172a', marginBottom: 6 }}>
                    {Number(row.amount).toLocaleString()}원
                  </div>
                )}
                <div style={{ fontSize: 11, color: '#64748b', marginBottom: 8 }}>
                  신고: {(row.disputed_at || '').slice(0, 16)}
                </div>
                {row.dispute_reason && (
                  <div style={{ fontSize: 12, color: '#1e293b', background: '#fff1f2', padding: '8px 10px', borderRadius: 6, marginBottom: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                    {row.dispute_reason}
                  </div>
                )}
                {/* Wave TW-1.f.16 — 예상 페널티 안내 */}
                <div style={{ fontSize: 10, color: '#64748b', background: '#f8fafc', padding: '6px 10px', borderRadius: 4, marginBottom: 10, lineHeight: 1.5 }}>
                  {row.dispute_party === 'seller' ? (
                    <>
                      <div><b>인정 시:</b> 외부 바이어 누적 → blacklist (3건)</div>
                      <div><b>기각 시:</b> 출품자 회사 -0.5° (부당 신고)</div>
                    </>
                  ) : (
                    <>
                      <div><b>인정 시:</b> 출품자 회사 -2.0° (실 위반)</div>
                      <div><b>기각 시:</b> 외부 바이어 -0.5° (부당 신고)</div>
                    </>
                  )}
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button type="button"
                    disabled={busyId === row.id}
                    onClick={function () { onResolve(row, 'resolved'); }}
                    style={{
                      flex: 1, padding: '8px 0', background: '#dc2626', color: 'white',
                      border: 'none', borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: 'pointer',
                    }}>
                    인정
                  </button>
                  <button type="button"
                    disabled={busyId === row.id}
                    onClick={function () { onResolve(row, 'rejected'); }}
                    style={{
                      flex: 1, padding: '8px 0', background: 'white', color: '#475569',
                      border: '1.5px solid #cbd5e1', borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: 'pointer',
                    }}>
                    기각
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default AdminDisputesPage;
